import 'css-chunksrc/client/pages/projectPage/synthesisPage/monitoring/stats/styles.scss';export default {
  "stats": "_stats_lblug_1",
  "col": "_col_lblug_8",
  "row": "_row_lblug_13",
  "label": "_label_lblug_23",
  "value": "_value_lblug_31"
};